import {LoginContext} from 'components/LoginContext'
import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash"


const RequiredAdmin = ({children, type, renderEmpty = NullAsDefault}) => {
  const login = useContext(LoginContext)
  const {edit_system = false} = login ?? {}
  if (!edit_system) {
    if (login && type) {
      if (_.get(login, 'permission_roles.' + type, false)) {
        return children
      }
    }
    return renderEmpty()
  }
  return children
}

export const SystemPermission = ({children, system}) => {
  const login = useContext(LoginContext)
  const {edit_system = false} = login ?? {}
  return children(edit_system)
};

export const RequiredSystemAdmin = (props) => (
  <RequiredAdmin
    {...props}
    system={true}
  />
)

export default RequiredAdmin
